import cn from 'classnames';

import s from './Shimmer.module.scss';
import StoreAppBar from 'src/modules/parkplusStoreV2/uiComponents/StoreAppBar';

const DOT_SHIMMER_REPEAT = [1, 2, 3, 4];
const QUICK_FACTS_SHIMMER_REPEAT = [1, 2, 3];
const BENEFITS_SHIMMER_REPEAT = [1, 2, 3, 4];

export const Shimmer = () => (
  <div className={s.root}>
    <StoreAppBar
      title=""
      showCart
      showFuel
      showShare
      renderAppBarOnly
      isSticky
    />
    <div className={s.shimmer}>
      <div className={s.carousel}>
        <div className={cn(s.card, 'cmn_shimmer')} />
        <div className={s.dot_container}>
          {DOT_SHIMMER_REPEAT.map((item) => (
            <div className={cn(s.dot, 'cmn_shimmer')} key={item} />
          ))}
        </div>
      </div>

      <div className={s.basic_info}>
        <div className={s.name}>
          <div className={cn(s.product_name, 'cmn_shimmer')} />
          <div className={cn(s.product_size, 'cmn_shimmer')} />
        </div>
        <div className={cn(s.price, 'cmn_shimmer')} />
      </div>

      <div className={s.quick_facts}>
        {QUICK_FACTS_SHIMMER_REPEAT.map((item) => (
          <div className={s.fact} key={item}>
            <div className={cn(s.fact_image, 'cmn_shimmer')} />
            <div className={cn(s.fact_title, 'cmn_shimmer')} />
          </div>
        ))}
      </div>

      <div className={s.benefits}>
        <div className={cn(s.heading, 'cmn_shimmer')} />
        <ul>
          {BENEFITS_SHIMMER_REPEAT.map((item) => (
            <li key={item} className={cn(s.benefit, 'cmn_shimmer')} />
          ))}
        </ul>
      </div>
    </div>
  </div>
);
